import { getSummary, isReorderedOnly, isUnchangedValue } from './arrayDiff';
import { humanizeKey, isLongTextChange } from './formatters';
import { isStandaloneImageKey, renderDisplayValue } from './renderers';
import type { ChangedField, DisplayChange } from './types';

export function createDisplayChange({ key, prev, next }: ChangedField): DisplayChange {
  const label = humanizeKey(key);
  const allowStringImageId = isStandaloneImageKey(key);
  const isLongText = isLongTextChange(prev, next);
  const summary = getSummary(key, prev, next);

  return {
    key,
    prev,
    next,
    label,
    summary,
    isLongText,
    isUnchanged: isUnchangedValue(prev, next),
    isReordered: isReorderedOnly(prev, next),
    oldDisplay: renderDisplayValue(prev, key, `Before ${label}`, {
      allowStringImageId,
      compareValue: next,
      panel: 'before',
    }),
    newDisplay: renderDisplayValue(next, key, `After ${label}`, {
      allowStringImageId,
      compareValue: prev,
      panel: 'after',
    }),
  };
}
